import type { ChangeEvent } from "react";

import { BigNumber } from "bignumber.js";

import { checkValueDecimalsCount } from "./check-value-decimals-count";

export const handleChangeWithCheckCoinDecimals =
  (
    onChange: (value: number | string) => void,
    decimal: number | string = 2,
    isNumber?: boolean,
  ) =>
  (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const { afterPoint, check, value } = checkValueDecimalsCount(
      inputValue,
      Number(decimal),
    );
    if (check) {
      onChange(isNumber ? BigNumber(inputValue).toNumber() : inputValue);
    } else {
      const resp = `${value}.${afterPoint.slice(0, Number(decimal))}`;
      onChange(isNumber ? BigNumber(resp).toNumber() : resp);
    }
  };
